// extracted by extract-css-chunks-webpack-plugin
module.exports = {"quote":"css-x9A2G47lxO"};